//@flow

const activeApiCallReducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_ACTIVE_API_CALL":
      if (state.includes(action.name)) {
        return state;
      } else {
        return [...state, action.name];
      }
    case "REMOVE_ACTIVE_API_CALL":
      if (state.includes(action.name)) {
        return state.filter(name => name !== action.name);
      } else {
        return state;
      }
    case "DROP_ACTIVE_API_CALL":
      return [];
    default:
      return state;
  }
};

export default activeApiCallReducer;
